import PropTypes from "prop-types";
import "../assets/css/components.css";

export const Checkbox = ({
  name = "",
  type = "checkbox",
  placeholder = "",
  checked = false,
  onChange = () => {},
  errorMsg,
  isMandatory = true,
}) => {
  const inputProps = {
    name,
    type,
    placeholder,
    checked,
    onChange,
  };

  return (
    <div className="wrapper">
      <label className="form-label">
        {placeholder}
        {isMandatory && <span className="mandatory-field">*</span>}
      </label>
      <input {...inputProps} className="field" onChange={onChange} />
      {errorMsg && <span className="error-message">{errorMsg}</span>}
    </div>
  );
};

Checkbox.propTypes = {
  name: PropTypes.string,
  type: PropTypes.any,
  placeholder: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  errorMsg: PropTypes.any,
  isMandatory: PropTypes.bool,
};
